'use es6';

import quickFetch from 'quick-fetch';
export const maybeEarlyRequest = (requestName, requestCb) => {
  const earlyRequest = requestName && quickFetch.getRequestStateByName(requestName);
  if (earlyRequest) {
    const earlyRequestPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError(() => {
        // retry the request
        requestCb().then(resolve).catch(err => {
          reject(err);
        });
        quickFetch.removeEarlyRequest(requestName);
      });
    });
    return earlyRequestPromise;
  }
  return requestCb();
};